import { ITEMS_SUCCESSFULLY_ADDED } from 'redux/modules/trolley-errors/actions/types';

const itemsSuccessfullyAddedToTrolley = (count = 0) => ({
  payload: { count },
  type: ITEMS_SUCCESSFULLY_ADDED,
});

export default itemsSuccessfullyAddedToTrolley;
